import { Injectable } from '@angular/core';
import { cacheable } from '@datorama/akita';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from '../shared/services/core/api.service';
import { CardLinkOfferLocationsStore } from './card-link-offer-locations.store';
import { CardLinkingOfferLocations } from './models/card-link-offer-location.model';

@Injectable({ providedIn: 'root' })
export class CardLinkOfferLocationsService {
  constructor(private api: ApiService, private cardLinkOfferLocationsStore: CardLinkOfferLocationsStore) {}

  /**
   * fatch Offer Location from api and set to the store
   * @param offerId is the id of the offer which user want to activate.
   */
  fetchOfferLocations(offerId: number) {
    const request$: Observable<CardLinkingOfferLocations> = this.api
      .getAnySingle<CardLinkingOfferLocations>('affiliates/offers/' + offerId)
      .pipe(
        tap((offerLocations) => {
          this.cardLinkOfferLocationsStore.add(offerLocations);
        })
      );
    return cacheable(this.cardLinkOfferLocationsStore, request$);
  }
}
